import {VImg,} from 'vuetify/components'
import {notifyError,} from '@/assets/js/src/util/bugsnag'

const BsVImg = {
    name: 'bs-v-img',
    extends: VImg,
    setup (props, ctx) {
        return {
            ...VImg.setup(props, ctx),
            // local bindings
        }
    },
    computed: {
        __cachedImage () {
            if (!(this.normalisedSrc.src || this.normalisedSrc.lazySrc)) return []
            const backgroundImage = []
            const src = this.isLoading ? this.normalisedSrc.lazySrc : this.currentSrc
            if (this.gradient) backgroundImage.push(`linear-gradient(${this.gradient})`)
            if (src) backgroundImage.push(`url("${src}")`)
            const image = this.$createElement('div', {
                staticClass: 'v-image__image',
                class: {
                    'v-image__image--preload': this.isLoading,
                    'v-image__image--contain': this.contain,
                    'v-image__image--cover': !this.contain,
                },
                style: {
                    backgroundImage: backgroundImage.length ? backgroundImage.join(', ') : 'none',
                    backgroundPosition: this.position,
                },
                key: +this.isLoading,
            })
            /* istanbul ignore if */

            if (!this.transition) return image

            return this.$createElement('transition', {
                attrs: {
                    name: this.transition,
                    mode: 'in-out',
                },
            }, [ image, ])
        },
    },
    methods: {
        onError () {
            !import.meta.env.SSR && fetch(this.src,{method:'GET',mode:'no-cors',}).then((res)=>{
                res.status !== 200 && notifyError(new Error(`Bild fehlt: ${this.src}`),{
                    httpStatus: res.status,
                    type: res.type,
                })
            }).catch((e)=>{
                notifyError(new Error(`Bild fehlt: ${this.src}`),{
                    exception: e.message,
                })
            })
        },
    },
}

export default BsVImg